<template>
  <div id="preview">
    <overlay-loading-progress :LoadingFlag="OverlayLoadingFlag" />
    <v-card class="rounded-xl elevation-3">
      <v-app-bar
        color="primary"
        dense
        dark
        elevate-on-scroll
        scroll-target="#scrolling-techniques-7"
      >
        <v-toolbar-title>{{ pageDescription }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closePrompt">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <v-card-text>
        <!-- Skeleton while loading -->
        <v-container class="py-0" v-if="StartupLoadingFlag">
          <v-skeleton-loader v-bind="attrs" type="table-tbody" />
        </v-container>

        <!-- Main content -->
        <v-container v-if="ResultFlag" class="py-6">
          <v-row justify="center">
            <v-col cols="12" md="8">
              <v-card outlined class="pa-8 rounded-xl elevation-1 text-center">
                <v-icon size="70" color="primary" class="mb-4">
                  mdi-account-tie
                </v-icon>

                <h2 class="font-weight-bold mb-2 text-primary">
                  Co-Option Nomination Approval
                </h2>

                <p class="text-subtitle-1 grey--text text--darken-1 mb-4">
                  You are reviewing a Co-Option nomination. Please verify all
                  details before approving or rejecting. Once approved, the
                  member will officially join under Co-Option.
                </p>

                <v-divider class="my-6"></v-divider>

                <h3 class="font-weight-medium mb-4">Take Action</h3>

                <!-- Buttons (Same functionality, better look) -->
                <v-row
                  justify="center"
                  class="mt-2 d-flex justify-center gap-6"
                >
                  <v-btn
                    @click.prevent="submitForm(4)"
                    color="green darken-1"
                    elevation="8"
                    rounded
                    large
                    class="px-10 py-4 white--text"
                  >
                    <v-icon left>mdi-check-circle</v-icon>
                    Selected
                  </v-btn>

                  <v-btn
                    @click.prevent="submitForm(5)"
                    color="red darken-1"
                    elevation="8"
                    rounded
                    large
                    class="px-10 py-4 white--text"
                  >
                    <v-icon left>mdi-close-circle</v-icon>
                    Not Selected
                  </v-btn>
                </v-row>

                <v-divider class="my-6"></v-divider>

                <p class="text-body-2 grey--text text--darken-2 mt-2">
                  ⚠️ Once action is taken, it cannot be undone. Please confirm
                  before proceeding.
                </p>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    row: {
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      recordData: [],
      TrainingDocuments: [],
      ResultFlag: false,
      StartupLoadingFlag: false,

      OverlayLoadingFlag: false,
      ReportType: "",
      valid1: true,
    };
  },
  computed: {},
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    recordData: function () {
      console.log("watch recordData");
      this.StartupLoadingFlag = false;
      var tr = this.recordData;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      this.ResultFlag = n1 > 0 ? true : false;
      this.ReportType = n1 > 0 ? tr.CategoryName : "";
      this.TrainingDocuments = n1 > 0 ? tr.TrainingDocuments : [];
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideDialog", true);
    },
    validate() {
      console.log("validate is called");
      var result = this.$refs.form.validate();
      console.log("result=" + result);
      if (result) {
        this.addRecordDetails();
      } else {
        console.log("some errors occured");
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.getRecordDetails();
    },
    getRecordDetails() {
      console.log("getRecordDetails called");
      this.ResultFlag = false;
      this.StartupLoadingFlag = true;
      this.TrainingDocuments = [];
      var tr = this.row;
      console.log({ tr });
      var id = tr.NominationId;
      var list_url = "api/nomination/show";
      var where = {
        Nomination: id,
      };
      console.log("list_url=" + list_url + ", where=" + JSON.stringify(where));
      this.getTableData("recordData", list_url, where);
    },
    submitForm(Status) {
      console.log("submitForm is called");

      console.log({ Status });

      var message = "";

      var tr = this.row;
      console.log({ tr });

      var id = tr.NominationId;
      console.log(id);

      // var validate1 = false;

      if (Status > 0 && id > 0) {
        this.OverlayLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url =
          server_url + "api/nomination/update-nomintionion-result-status";
        var upload = {
          UserInterface: 1,
          Nomination: id,
          ResultStatus: Status,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.StatusFlag = false;

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));
            thisIns.OverlayLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.StatusFlag = true;
              thisIns.sweetAlert("success", output, true);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
          });
      } else {
        if (!validate1) {
          message = "Kindly fill the required fields. ";
        }
        if (Status == null || Status == "") {
          message = "Status is invalid. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
